<template>
  <form @submit.prevent="onSubmit">
    <div v-if="alert.message">
      <div class="alert"
        :class="'alert-' + alert.type">
        {{ alert.message }}
      </div>
    </div>
    <div class="form-group row">
      <label for="cream-name" class="col-sm-2 col-form-label">Sorte</label>
      <div class="col offset-sm-1">
        <input type="text" v-model="cream.name" required
          class="form-control" id="cream-name">
      </div>
    </div>
    <div class="form-group row">
      <div class="form-check col offset-sm-3">
        <label class="form-check-label">
          <input class="form-check-input" type="checkbox" v-model="cream.vegan">
          Vegan
        </label>
      </div>
    </div>
    <div class="form-group row">
      <div class="form-check col offset-sm-3">
        <label class="form-check-label">
          <input class="form-check-input" type="checkbox" v-model="cream.lactosefree">
          Laktosefrei
        </label>
      </div>
    </div>
    <div class="form-group row">
      <div class="form-check col offset-sm-3">
        <label class="form-check-label">
          <input class="form-check-input" type="checkbox" v-model="cream.glutenfree">
          Glutenfrei
        </label>
      </div>
    </div>
    <div class="form-group row">
      <label for="cream-image" class="col-sm-2 col-form-label">Bild</label>
      <div class="col offset-sm-1">
        <div class="cream-image" v-if="cream.imagePath">
          <img :src="`/${cream.imagePath}?${cacheBust}`">
        </div>
        <input type="file" @change="onChangeFile" :required="!isExisting"
          class="form-control" id="cream-image">
      </div>
    </div>
    <div class="form-group row">
      <div class="col offset-3">
        <button type="submit" class="btn btn-primary save">Speichern</button>
        <router-link to="/creams" class="back">Zurück</router-link>
      </div>
    </div>
    <div class="form-group row">
      <div class="col offset-3">
        <button v-if="isExisting" @click.prevent="onDelete"
          class="btn btn-secondary delete">
          Löschen
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  data () {
    return {
      image: {}
    }
  },

  props: {
    cream: {
      type: Object,
      default () {
        return {
          name: '',
          imagePath: '',
          vegan: false,
          lactosefree: false,
          glutenfree: true
        }
      }
    },
    alert: {
      type: Object
    }
  },

  watch: {
    'cream.vegan': function (vegan) {
      this.cream.lactosefree = vegan
    }
  },

  computed: {
    isExisting () {
      return !!(this.cream.id)
    },

    cacheBust () {
      return Math.floor(Math.random() * 1000000)
    }
  },

  methods: {
    onChangeFile (event) {
      const file = event.target.files[0]
      if (file) {
        this.image = file
      }
    },

    onSubmit () {
      this.$emit('submit', {
        cream: this.cream,
        form: form(this.cream, this.image)
      })
    },

    onDelete () {
      this.$emit('delete', this.cream)
    }
  }
}

function form (cream, image) {
  const form = new FormData()
  form.append('cream', JSON.stringify(cream))
  form.append('image', image)
  return form
}
</script>

<style scoped lang="scss">
  @import '../../../assets/styles/variables';

  form {
    max-width: 400px;
  }

  a.back {
    margin: 0 $spacer-x;
  }

  .btn.delete:hover {
    background-color: $brand-danger;
    border-color: $brand-danger;
    color: $white;
  }

  .cream-image {
    margin: $spacer-y 0;
    width: 150px;
    height: 169px;
    overflow: hidden;

    > img {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// _form.vue?c9ff9cc8